var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20.0909C8.25909 20.0909 7.19886 19.6614 6.31932 18.8023C5.43977 17.9432 5 16.8932 5 15.6523C5 14.5886 5.32045 13.6409 5.96136 12.8091C6.60227 11.9773 7.44091 11.4455 8.47727 11.2136C8.81818 9.95909 9.5 8.94318 10.5227 8.16591C11.5455 7.38864 12.7045 7 14 7C15.5955 7 16.9489 7.55568 18.0602 8.66705C19.1716 9.77841 19.7273 11.1318 19.7273 12.7273C20.6682 12.8364 21.4489 13.242 22.0693 13.9443C22.6898 14.6466 23 15.4682 23 16.4091C23 17.4318 22.642 18.3011 21.9261 19.017C21.2102 19.733 20.3409 20.0909 19.3182 20.0909H14.8182C14.3682 20.0909 13.983 19.9307 13.6625 19.6102C13.342 19.2898 13.1818 18.9045 13.1818 18.4545V14.2409L11.8727 15.5091L10.7273 14.3636L14 11.0909L17.2727 14.3636L16.1273 15.5091L14.8182 14.2409V18.4545H19.3182C19.8909 18.4545 20.375 18.2568 20.7705 17.8614C21.1659 17.4659 21.3636 16.9818 21.3636 16.4091C21.3636 15.8364 21.1659 15.3523 20.7705 14.9568C20.375 14.5614 19.8909 14.3636 19.3182 14.3636H18.0909V12.7273C18.0909 11.5955 17.692 10.6307 16.8943 9.83295C16.0966 9.03523 15.1318 8.63636 14 8.63636C12.8682 8.63636 11.9034 9.03523 11.1057 9.83295C10.308 10.6307 9.90909 11.5955 9.90909 12.7273H9.5C8.70909 12.7273 8.03409 13.0068 7.475 13.5659C6.91591 14.125 6.63636 14.8 6.63636 15.5909C6.63636 16.3818 6.91591 17.0568 7.475 17.6159C8.03409 18.175 8.70909 18.4545 9.5 18.4545H11.5455V20.0909H9.5Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.835d83a4268175cbd6d85dbf00d2dd8d.svg";
export { ForwardRef as ReactComponent };